module.exports = __webpack_public_path__ + "img/choice.962cb3d8.png";